import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'react-addons-update';
import { Icon, Button } from 'semantic-ui-react';

import cm from 'helpers/commons';
import * as cmAPI_Action from 'actions/commons';

const propTypes = {};

const defaultProps = {};

class DefaultSikdaePolicySelBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: update(this.state.value, { $set: 0 })
    });
  }

  sikdaePolicySearch = (e, event) => {
    const { handleChange, individual, btnFunc, sikdaeGroupVal } = this.props;
    console.log(e.target.value, event);

    let type = individual ? '' : 'all';

    if (event === 'all') {
      btnFunc('policy', sikdaeGroupVal, this.state.value);
    } else {
      this.setState({
        value: update(this.state.value, { $set: e.target.value })
      });
      handleChange(e, type, e.target.value);
    }
  };

  render() {
    const { value } = this.state;
    const { sikdaePolicy, sikdaeGroupVal, style, welfare, longterm, defaultValue, individual, id, isBtn, isIcon } = this.props;

    let options = null;
    let count = 0;
    let defVal = value !== 0 ? value : defaultValue;

    if (sikdaePolicy && sikdaePolicy.data) {
      const { policy } = sikdaePolicy.data;

      options = policy.map((data, i) => {
        if (longterm) {
          if (data.type === 'LONGTERM') {
            return !individual ? (
              data.isactive ? (
                <option value={data.idx} key={data.idx}>
                  {data.name}
                </option>
              ) : null
            ) : (
              <option value={data.idx} key={data.idx}>
                {data.name}
              </option>
            );
          }
        } else {
          return data.isactive ? (
            <option value={data.idx} key={data.idx}>
              {data.name}
            </option>
          ) : null;
        }
      });
    }

    let iconStyle = defVal == 0 ? 'unset' : 'none';

    return (
      <div>
        <select
          className="default-sel"
          style={{ float: 'left' }}
          // value={defaultValue}
          value={defVal}
          id={id}
          onChange={this.sikdaePolicySearch}
        >
          <option value="0" key={0}>
            {`${welfare ? '복지' : '식대'}정책`}
          </option>
          {options}
        </select>
        {isIcon ? (
          <Icon
            className={'checkIcon' + defVal}
            ref="icon"
            name="warning circle"
            color="red"
            style={{ display: iconStyle }}
          />
        ) : null}

        {isBtn ? (
          <Button inverted color="black" onClick={(e) => this.sikdaePolicySearch(e, 'all')}>
            모두적용
          </Button>
        ) : null}
      </div>
    );
  }
}

DefaultSikdaePolicySelBox.propTypes = propTypes;
DefaultSikdaePolicySelBox.defaultProps = defaultProps;

DefaultSikdaePolicySelBox = connect(
  (state) => ({
    // sikdaePolicy    : state.commons.sikdaePolicy,
    policyIdx: state.commons.policy
  }),

  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changePolicy: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(DefaultSikdaePolicySelBox);

export default DefaultSikdaePolicySelBox;
